import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import { toggleSelectionWindow, setStep } from "../../actions/actionFunctions";
import Analytics from './../../analytics';

class SelectionMainSelect extends Component {

  static propTypes = {
    type: PropTypes.number.isRequired,
    parentItems: PropTypes.array,
    relatedItems: PropTypes.array,
    relatedItemClick: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
      showRelatedItems: false
    };
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleWrapperBlur);
  }

  handleItemClick = (e) => {
    const parentItem = this.props.parentItems[e.target.dataset.index].part;
    this.props.toggleSelectionWindow(true, parentItem.partName);
    this.props.setStep(e.target.dataset.index);
    let showRelatedItems = true;
    if (parentItem.menuType === 0 || parentItem.partName === "Toilet") {
      showRelatedItems = false;
      this.handleToggleDropdown();
    }
    this.setState({
      showRelatedItems
    });
  };

  handleRelatedItemClick = (e) => {
    Analytics.sendClickEvent('related-item');
    this.props.relatedItemClick(+e.target.dataset.index);
    this.handleToggleDropdown();
    setTimeout(() => {
      this.setState({
        showRelatedItems: false
      });
    }, 500)
  };

  handleBackClick = () => {
    Analytics.sendClickEvent('back');
    this.setState({
      showRelatedItems: false
    });
  };

  handleToggleDropdown = () => {
    this.setState({
      toggle: !this.state.toggle
    }, () => {
      setTimeout(() => {
        this.state.toggle
          ? window.addEventListener('click', this.handleWrapperBlur)
          : window.removeEventListener('click', this.handleWrapperBlur)
      }, 0)
    })
  };

  handleWrapperBlur = (e) => {
    if (this.state.toggle && !e.target.closest('.ui-select2__dropdown-list-item')
      && !e.target.closest('.ui-select2__dropdown-back') && !e.target.closest('.ui-select2__dropdown')) {
      this.handleToggleDropdown();
    }
  };

  render() {

    const baseClass = this.props.type === 1 ? "ui-select" : "ui-select"+this.props.type;
    const dropDownStyles = this.state.toggle ? { height:window.innerHeight - 60 } : {};
    if (this.state.toggle) {
      dropDownStyles.height = (this.props.windowWidth > 991 && window.innerHeight > 320) ? 320 : window.innerHeight - 60
    }

    return (
      <div className={baseClass + (this.state.toggle ? ` ${baseClass}--opened` : "")}>
        <div className={baseClass+"__input"} onClick={this.handleToggleDropdown}>
          <span className={baseClass+"__input-label"}>
            <FormattedMessage id="quotingTool.footer.selectDropdownSortBy"/>
          </span>
          <span className={baseClass+"__input-value"}>
            {this.props.relatedItems && this.props.relatedItems.length && this.props.relatedItems[this.props.activePartRelatedItemIndex]
              ? this.props.relatedItems[this.props.activePartRelatedItemIndex].text : this.props.selectionGroup}
          </span>
        </div>
        <div className={baseClass+"__dropdown"} style={dropDownStyles}>
          {this.state.showRelatedItems
            ? <button className={baseClass+"__dropdown-back"} onClick={this.handleBackClick}>Back</button>
            : null}
          <ul className={baseClass+"__dropdown-list"}>
            {this.state.showRelatedItems ? this.props.relatedItems.map((relatedItem, index) => {
              return (
                <li key={"dropdownRelated"+index}
                    data-index={index}
                    onClick={this.handleRelatedItemClick}
                    className={baseClass+"__dropdown-list-item"
                    + ` ${baseClass}__dropdown-list-item--${relatedItem.text.toLowerCase().replace(/ /g,"_")}`}>
                  {relatedItem.text}
                </li>
              )
            }) : this.props.parentItems.map((parentItem, index) => {
              const bvPart = parentItem.part.partName;
              return (
                <li key={"dropdown"+index}
                    data-index={index}
                    onClick={this.handleItemClick}
                    className={baseClass+"__dropdown-list-item"
                    + (bvPart === this.props.selectionGroup ? ` ${baseClass}__dropdown-list-item--active` : "")
                    + ` ${baseClass}__dropdown-list-item--${bvPart.toLowerCase().replace(/ /g,"_")}`}>
                  {bvPart}
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    selectionGroup: store.selectionState.selectionGroup,
    layoutParts: store.stepsState.layoutParts,
    windowWidth: store.serverState.windowWidth,
    activePartRelatedItemIndex: store.selectionState.activePartRelatedItemIndex,
  };
};

export default connect(mapStateToProps, {
  toggleSelectionWindow,
  setStep
})(SelectionMainSelect);
